var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overlay-container"},[(_vm.show)?_c('div',{staticClass:"custom-overlay"},[_vm._m(0)]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overlay-spinner",attrs:{"role":"status"}},[_c('span',{staticClass:"visually-hidden"},[_vm._v("Loading...")])])
}]

export { render, staticRenderFns }